$(function() {

    // Define variables
    const collectionProviderURL = $.p("collectionProvider", "recycling");
    const singleProviderURL = $.p("singleProvider", "recycling");
    const regionProviderURL = $.p("regionCollectionProvider", "recycling");
    const cityProviderURL = $.p("cityCollectionProvider", "recycling");
    const pointProviderURL = $.p("pointCollectionProvider", "recycling");
    const nearestBoundsProviderURL = $.p("nearestBoundsProvider", "recycling");
    const cityAutocompleteProviderURL = $.p("cityAutocompleteProvider", "recycling");
    const markerIconURL = $.p("markerIcon", "recycling");

    // Translation
    const chooseProvinceTranslation = $.p("chooseProvinceTranslation", "recycling");
    const chooseCityTranslation = $.p("chooseCityTranslation", "recycling");
    const showOnMapTranslation = $.p("showOnMapTranslation", "recycling");
    const noNearPointsTranslation = $.p("noNearPointsTranslation", "recycling");
    const errorLocateTranslation = $.p("errorLocateTranslation", "recycling");

    $("#mapContainer").pointsMapPlugin({
        searchInput: $("#searchInput"),
        onlinePositionButton: $("#onlinePositionButton"),
        markerConfig: {
            iconURL: markerIconURL,
            iconSize: [25, 32]
        },
        dataProvider: {
            collectionProviderURL: collectionProviderURL,
            singleProviderURL: singleProviderURL,
            regionProviderURL: regionProviderURL,
            cityProviderURL: cityProviderURL,
            pointProviderURL: pointProviderURL,
            nearestBoundsProviderURL: nearestBoundsProviderURL,
            cityAutocompleteProviderURL: cityAutocompleteProviderURL
        },
        container: {
            regionChoice: $("#regionChoice"),
            cityChoice: $("#cityChoice"),
            pointChoice: $("#pointChoice"),
            pointDetails: $("#pointDetails")
        },
        translation: {
            "Please choose a province": chooseProvinceTranslation,
            "Please choose a city": chooseCityTranslation,
            "Show on the map": showOnMapTranslation,
            "Unfortunately, there are no points near your location": noNearPointsTranslation,
            "Unfortunately, we can not determine your location": errorLocateTranslation
        }
    });
});

//# sourceMappingURL=recycling.js.map
